<template>
  <div>
    <div v-if="existingUrl && !deleted && !value" class="image-upload-preview">
      <button type="button" class="btn btn-danger btn-sm" @click="$emit('update:deleted', true)">
        <i class="fa fa-trash"></i>
      </button>
      <a :href="existingUrl" target="_blank" data-fancybox="gallery">
        <img class="img-thumbnail" :src="existingUrl">
      </a>
    </div>

    <input type="file"
           :accept="accept"
           class="form-control"
           @change="onChange">
  </div>
</template>

<script>
export default {
  name: 'ImageUploadWithPreview',
  props: {
    existingUrl: {type: String, default: null},
    value: {default: null},
    deleted: {type: Boolean, default: false},
    accept: {type: String, default: 'image/jpeg, image/png, image/webp'},
  },
  methods: {
    onChange(event) {
      const file = event.target.files[0] || null;
      this.$emit('input', file);

      if (file) {
        this.$emit('update:deleted', false);
      }
    },
  },
}
</script>

<style scoped>
.image-upload-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.img-thumbnail {
  max-height: 80px;
}
</style>